<template>
  <a-icon type="copy" @click="copyText" />
</template>

<script>
export default {
  props: {
    txt: {
      type: String,
    },
  },
  name: "copy",
  data() {
    return {};
  },
  methods: {
    async copyText() {
      // await navigator.clipboard.writeText(this.txt);
      // this.$toast("Copiado com êxito");
      this.$utils.copy(this.txt);
      this.$toast(this.$t("Copied successfully"));
    },
  },
};
</script>

<style lang="less" scoped></style>
